import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SipIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sip"}/>
}
